import React from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import ProjectsPage from '../pages/projects/page';
import PricesPage from '../pages/prices/page';
import ContactPage from '../pages/contact/page';
import ConsultationPage from '../pages/consultation/page';
import QuotePage from '../pages/quote/page';
import FAQsPage from '../pages/faqs/page';
import PrivacyPage from '../pages/privacy/page';
import CookiesPage from '../pages/cookies/page';
import BlogPage from '../pages/blog/page';
import NotFoundPage from '../pages/NotFound';

// Import existing service pages
import SocialMediaContentPage from '../pages/services/social-media-content/page';
import DesignPage from '../pages/services/design/page';
import SEOPage from '../pages/services/seo/page';
import GoogleMyBusinessPage from '../pages/services/google-my-business/page';
import SocialMediaPage from '../pages/services/social-media/page';
import ContentPage from '../pages/services/content/page';
import DigitalMarketingPage from '../pages/services/digital-marketing/page';
import VirtualToursPage from '../pages/services/virtual-tours/page';
import PPCCampaignsPage from '../pages/services/ppc-campaigns/page';
import ReputationPage from '../pages/services/reputation/page';
import ReportingAnalyticsPage from '../pages/services/reporting-analytics/page';
import SecurityPage from '../pages/services/security/page';

// Import new service pages for home page services
import WebDesignPage from '../pages/services/web-design/page';
import BusinessListingsPage from '../pages/services/business-listings/page';
import LocalSEOPage from '../pages/services/local-seo/page';
import PPCAdCampaignManagementPage from '../pages/services/ppc-ad-campaign-management/page';
import GoogleMyBusinessManagementPage from '../pages/services/google-my-business-management/page';

// Import blog article pages
import DigitalMarketingTips2024 from '../pages/blog/articles/digital-marketing-tips-2024/page';
import GoogleMyBusinessSetup from '../pages/blog/articles/google-my-business-setup/page';
import SocialMediaContentCalendar from '../pages/blog/articles/social-media-content-calendar/page';
import FreeMarketingTools from '../pages/blog/articles/free-marketing-tools/page';
import LocalSEOGuide from '../pages/blog/articles/local-seo-guide/page';
import StartupMarketingBudget from '../pages/blog/articles/startup-marketing-budget/page';
import WebsiteManagement from '../pages/blog/articles/website-management/page';
import WebsiteMarketing from '../pages/blog/articles/website-marketing/page';
import CustomerCareExcellence from '../pages/blog/articles/customer-care-excellence/page';
import ShoestringBudgetMarketing from '../pages/blog/articles/shoestring-budget-marketing/page';
import FreeResources from '../pages/blog/articles/free-resources/page';
import SocialMediaEngagement from '../pages/blog/articles/social-media-engagement/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/projects',
    element: <ProjectsPage />
  },
  {
    path: '/prices',
    element: <PricesPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/consultation',
    element: <ConsultationPage />
  },
  {
    path: '/quote',
    element: <QuotePage />
  },
  {
    path: '/faqs',
    element: <FAQsPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/cookies',
    element: <CookiesPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  // Blog article routes
  {
    path: '/blog/articles/digital-marketing-tips-2024',
    element: <DigitalMarketingTips2024 />
  },
  {
    path: '/blog/articles/google-my-business-setup',
    element: <GoogleMyBusinessSetup />
  },
  {
    path: '/blog/articles/social-media-content-calendar',
    element: <SocialMediaContentCalendar />
  },
  {
    path: '/blog/articles/free-marketing-tools',
    element: <FreeMarketingTools />
  },
  {
    path: '/blog/articles/local-seo-guide',
    element: <LocalSEOGuide />
  },
  {
    path: '/blog/articles/startup-marketing-budget',
    element: <StartupMarketingBudget />
  },
  {
    path: '/blog/articles/website-management',
    element: <WebsiteManagement />
  },
  {
    path: '/blog/articles/website-marketing',
    element: <WebsiteMarketing />
  },
  {
    path: '/blog/articles/customer-care-excellence',
    element: <CustomerCareExcellence />
  },
  {
    path: '/blog/articles/shoestring-budget-marketing',
    element: <ShoestringBudgetMarketing />
  },
  {
    path: '/blog/articles/free-resources',
    element: <FreeResources />
  },
  {
    path: '/blog/articles/social-media-engagement',
    element: <SocialMediaEngagement />
  },
  // Existing service subpages
  {
    path: '/services/social-media-content',
    element: <SocialMediaContentPage />
  },
  {
    path: '/services/design',
    element: <DesignPage />
  },
  {
    path: '/services/seo',
    element: <SEOPage />
  },
  {
    path: '/services/google-my-business',
    element: <GoogleMyBusinessPage />
  },
  {
    path: '/services/social-media',
    element: <SocialMediaPage />
  },
  {
    path: '/services/content',
    element: <ContentPage />
  },
  {
    path: '/services/digital-marketing',
    element: <DigitalMarketingPage />
  },
  {
    path: '/services/virtual-tours',
    element: <VirtualToursPage />
  },
  {
    path: '/services/ppc-campaigns',
    element: <PPCCampaignsPage />
  },
  {
    path: '/services/reputation',
    element: <ReputationPage />
  },
  {
    path: '/services/reporting-analytics',
    element: <ReportingAnalyticsPage />
  },
  {
    path: '/services/security',
    element: <SecurityPage />
  },
  // New service subpages for home page services
  {
    path: '/services/web-design',
    element: <WebDesignPage />
  },
  {
    path: '/services/business-listings',
    element: <BusinessListingsPage />
  },
  {
    path: '/services/local-seo',
    element: <LocalSEOPage />
  },
  {
    path: '/services/ppc-ad-campaign-management',
    element: <PPCAdCampaignManagementPage />
  },
  {
    path: '/services/google-my-business-management',
    element: <GoogleMyBusinessManagementPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;